import "amazon-connect-streams";
import React, {memo, useRef, useEffect} from "react";
import {LOGIN_URL, CCP_URL} from "../config"
import { genLogger } from "../lib";

const name = "ConnectCCP";
const { log, error } = genLogger(name);

const ConnectCCP = () => {
  const ref = useRef();

  useEffect(() => {
    try {
      log("init start");
      if (typeof window === "undefined") throw new Error("window missing");
      if (typeof window.connect === "undefined")
        throw new Error("global connect missing");
        if(LOGIN_URL === "NA")
        {
            window.connect.core.initCCP(ref.current, {
              ccpUrl: CCP_URL,
              //loginUrl: LOGIN_URL,
              loginPopup: true,
              loginPopupAutoClose: true,
              pageOptions: {
                enableAudioDeviceSettings: true,
                enablePhoneTypeSettings: true,
              },
              softphone: { allowFramedSoftphone: true },
            });
        }
        else {
          window.connect.core.initCCP(ref.current, {
            ccpUrl: CCP_URL,
            loginUrl: LOGIN_URL,
            loginPopup: true,
            loginPopupAutoClose: true,
            loginOptions: {                 // optional, if provided opens login in new window
              autoClose: true,              // optional, defaults to `false`
              height: 600,                  // optional, defaults to 578
              width: 500,                   // optional, defaults to 433
              top: 0,                       // optional, defaults to 0
              left: 0                       // optional, defaults to 0
            },
            pageOptions: {
              enableAudioDeviceSettings: true,
              enablePhoneTypeSettings: true,
            },
            softphone: { allowFramedSoftphone: true },
          });
        }
      log("init end");
    } catch (e) {
      error(e);
    }
  }, [ref]);

  log("render");
  return (
    <div
      ref={ref}
      style={{ width: "100%", height: "100%", minHeight: 480, minWidth: 400 }}
      // style={{ minWidth: 400, minHeight: 480 }}
    />
  );
};

export default memo(ConnectCCP);
